// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d03cf23c","455":"5998cf08","977":"402cdf73"}[chunkId] + ".chunk.js";
};